import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/tr';
import 'moment/locale/uk';
import { isProd } from './config';


function syncMomentLocale(lng) {
  if (!lng) return;
  // moment.locale falls back to 'en' if the requested locale isn't bundled
  moment.locale(lng.split('-')[0]);
}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: !isProd,

    detection: {
      // Note: navigator is missing, because I want users to choose the language from the dropdown
      order: ['querystring', 'localStorage', 'htmlTag'],
    }

    // interpolation: {
    //   escapeValue: false, // not needed for react as it escapes by default
    // }
  })
  .then(() => syncMomentLocale(i18n.language));

i18n.on('languageChanged', syncMomentLocale);

export default i18n;
